module.exports = __webpack_public_path__ + "static/media/cm.2b573cc5.svg";